export class ClientWallet {
  private static instance: ClientWallet;

  private publicKey: `0x${string}`;

  private constructor() {}

  get key(): `0x${string}` {
    return this.publicKey;
  }

  set key(value: `0x${string}`) {
    this.publicKey = value;
  }

  public static getInstance(): ClientWallet {
    if (!ClientWallet.instance) {
      ClientWallet.instance = new ClientWallet();
    }

    return ClientWallet.instance;
  }
}
